import { toZonedTime } from 'date-fns-tz';

/**
 * Возвращает строку смещения UTC для заданной таймзоны, например: "(UTC +3)" или "(UTC -4.5)"
 */
export function getUTCOffsetString(timeZone: string, date: Date = new Date()): string {
  const zonedDate = toZonedTime(date, timeZone);
  const offsetMinutes = zonedDate.getTimezoneOffset();
  const offsetHours = -offsetMinutes / 60;
  const sign = offsetHours >= 0 ? '+' : '-';
  const absOffset = Math.abs(offsetHours);

  const formattedOffset = Number.isInteger(absOffset) ? absOffset : absOffset.toFixed(1);

  return `UTC ${sign}${formattedOffset}`;
}
